import { isNonEmptyString } from './checks'

interface ReplaceCustomShortCodes {
  (props: {
    originalString: string
    count: number | string
    year: number
    secondaryTerm: string
    condition?: string
    location?: string
  }): string
}

const countRegex = /\[count\]/g
const yearRegex = /\[year\]/g
const secondaryTermRegex = /\[secondaryTerm\]/g
const conditionRegex = /\[condition\]/g
const locationRegex = /\[location\]/g

const replaceCustomShortCodes: ReplaceCustomShortCodes = ({
  originalString,
  count,
  year,
  secondaryTerm,
  condition = '',
  location = ''
}) => {
  if (isNonEmptyString(originalString)) {
    return originalString
      .replace(countRegex, count.toString())
      .replace(yearRegex, year.toString())
      .replace(secondaryTermRegex, secondaryTerm)
      .replace(conditionRegex, condition)
      .replace(locationRegex, location)
  }
  return ''
}

export default replaceCustomShortCodes
